/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ComponentStatus-badge{margin-right:5px}.ComponentStatus-div{display:inline-block}\n"}]);